{
  "site_dev_command_def.description": "Site Live dev command",
  "dev_command.welcome": "Welcome to the Site Live CLI",
  "dev_command.init.fetching_files": "Fetching latest code from Site..."
}
